module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-90deg-up-85eeb1f7.svg";